/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* session-recordings/assets/js/player.js — session list + rrweb-player replay.
 * Expects the DOM from frontend/pages.php (data-sr="…" hooks). Uses window.GS.api and window.rrweb.Replayer (driven directly with our own controls). */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["session-recordings"] = "2.3.0"; } catch (e) {}

  var TRIG = {
    rage_click: { label: TR('sessio.g.rage_click'), cls: "sr-b-red" },
    dead_click: { label: TR('sessio.g.dead_click'), cls: "sr-b-amber" },
    error:      { label: TR('sessio.g.js_error'),   cls: "sr-b-red" },
    manual:     { label: TR('sessio.g.manual'),     cls: "sr-b-blue" }
  };
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function fmtDur(ms) { ms = +ms || 0; var s = Math.round(ms / 1000), m = Math.floor(s / 60); return m + ":" + ("0" + (s % 60)).slice(-2); }
  function fmtWhen(iso) {
    if (!iso) return "—";
    var d = new Date(String(iso).replace(" ", "T") + "Z"); if (isNaN(d)) return esc(iso);
    var diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return Math.floor(diff / 60) + "m ago";
    if (diff < 86400) return Math.floor(diff / 3600) + "h ago";
    return d.toLocaleDateString();
  }
  function trigBadge(k) { var t = TRIG[k] || { label: k || "—", cls: "sr-b-grey" }; return '<span class="sr-badge ' + t.cls + '">' + esc(t.label) + "</span>"; }
  function trigLabel(k) { return (TRIG[k] || { label: k || "—" }).label; }
  function devIcon(d) {
    var i = d === "mobile" ? "phone" : (d === "tablet" ? "tablet" : "display");
    return '<i class="bi bi-' + i + '" title="' + esc(d) + '"></i>';
  }

  function ctl() {
    var d = document;
    return {
      list: d.querySelector('[data-sr="list"]'),
      trigger: d.querySelector('[data-sr="trigger"]'),
      rangeBtn: d.querySelector('[data-sr="rangeBtn"]'),
      rangeMenu: d.querySelector('[data-sr="rangeMenu"]'),
      rangeLabel: d.querySelector('[data-sr="range-label"]'),
      deviceBtns: d.querySelectorAll("[data-sr-device]"),
      mount: d.querySelector('[data-sr="mount"]'),
      title: d.querySelector('[data-sr="title"]'),
      meta: d.querySelector('[data-sr="meta"]'),
      empty: d.querySelector('[data-sr="empty"]'),
      pagechip: d.querySelector('[data-sr="pagechip"]'),
      install: d.querySelector('[data-sr="install"]')
    };
  }

  function init(root) {
    if (root._srWired || !window.GS || !GS.api) return;
    // Same reason as heatmap.js: without a resolved site every request 404s on an empty site=.
    if (!GS.site) { var _l = document.querySelector('[data-sr="list"]');
      if (_l) _l.innerHTML = '<tr><td colspan="6" class="gs-muted">'+TR('sessio.no_site_selected_yet_add_or_choose_a_site_to')+'</td></tr>';
      return; }
    root._srWired = 1;
    var c = ctl(), device = "", player = null, rows = [], _raf = 0, _onResize = null;
    if (!c.list || !c.mount) return;

    // Deep link from the heatmap cross-link (and shareable links): ?page= filters to a page,
    // ?trigger= pre-selects a trigger, ?id= auto-opens a specific recording.
    var dl = { page: "", trigger: "", id: 0, opened: false };
    try {
      var qp = new URLSearchParams(location.search);
      dl.page = (qp.get("page") || "").slice(0, 512);
      dl.trigger = (qp.get("trigger") || "").toLowerCase().replace(/[^a-z_]/g, "");
      /* Accept session_id as well as id: every deep link in the app names it session_id, and a
         receiver that only understands one spelling makes the link look broken. */
      dl.id = parseInt(qp.get("id") || qp.get("session_id") || qp.get("sid") || "0", 10) || 0;
    } catch (e) {}
    var pageFilter = dl.page || "";
    if (dl.trigger && c.trigger) c.trigger.value = dl.trigger;

    function updateUrl() {
      try { var u = new URL(location.href); if (pageFilter) u.searchParams.set("page", pageFilter); else u.searchParams.delete("page"); history.replaceState(null, "", u.toString()); } catch (e) {}
    }
    function renderChip() {
      if (!c.pagechip) return;
      if (pageFilter) {
        c.pagechip.hidden = false;
        c.pagechip.innerHTML = 'Recordings for <strong>' + esc(pageFilter) + '</strong> <button type="button" class="sr-chip-x" title="'+TT('sr.tip_clear')+'">&times;</button>';
        var x = c.pagechip.querySelector(".sr-chip-x");
        if (x) x.addEventListener("click", function () { pageFilter = ""; renderChip(); updateUrl(); loadList(); });
      } else { c.pagechip.hidden = true; c.pagechip.innerHTML = ""; }
    }
    function playById(id) {
      GS.api("/plugin/session-recordings/get?id=" + id + "&site=" + encodeURIComponent(GS.site || "")).then(function (r) {
        var s = (r.ok && r.data && r.data.session) || null; if (s) play(s);
      });
    }

    /* Date range — normalised to the shared devicedetector picker. */
    function _hmT(k, v) { return (window.GS && GS.t) ? GS.t(k, v) : k; }
    function _hmYmd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
    function _hmToday() { var n = new Date(); return new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate())); }
    function _hmPreset(days) { var to = _hmToday(), from = new Date(to.getTime() - (days - 1) * 86400000); var lbl = { 7: _hmT("an.last7"), 30: _hmT("an.last30"), 90: _hmT("an.last90"), 365: _hmT("an.last12mo") }[days] || (days + " days"); return { from: _hmYmd(from), to: _hmYmd(to), label: lbl, preset: String(days) }; }
    var RANGE = (function () { try { var s = JSON.parse(localStorage.getItem("gs_sr_range") || "null"); if (s && s.preset) return _hmPreset(+s.preset); if (s && s.from && s.to) return s; } catch (e) {} return _hmPreset(30); })();
    function _hmSave() { try { localStorage.setItem("gs_sr_range", JSON.stringify(RANGE)); } catch (e) {} }
    (function initRange() {
      var scope = document;
      var btn = scope.querySelector('[data-sr="rangeBtn"]'), menu = scope.querySelector('[data-sr="rangeMenu"]'), lab = scope.querySelector('[data-sr="range-label"]');
      if (!btn || !menu) return;
      if (lab && RANGE.label) lab.textContent = RANGE.label;
      function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === RANGE.preset); }); }
      btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); var open = menu.style.display !== "none"; menu.style.display = open ? "none" : "block"; if (!open) { var cf = menu.querySelector('[data-rp="from"]'), ct = menu.querySelector('[data-rp="to"]'); if (cf) cf.value = RANGE.from; if (ct) ct.value = RANGE.to; sync(); } });
      document.addEventListener("click", function (e) { if (!btn.contains(e.target)) menu.style.display = "none"; });
      function apply(r) { RANGE = r; if (lab) lab.textContent = RANGE.label; _hmSave(); menu.style.display = "none"; loadList(); }
      menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { apply(_hmPreset(+b.getAttribute("data-preset"))); }); });
      var ap = menu.querySelector('[data-rp="apply"]'); if (ap) ap.addEventListener("click", function () { var ff = menu.querySelector('[data-rp="from"]').value, tt = menu.querySelector('[data-rp="to"]').value; if (!ff || !tt) return; if (ff > tt) { var x = ff; ff = tt; tt = x; } apply({ from: ff, to: tt, label: ff + " \u2192 " + tt, preset: null }); });
    })();

    function stopTick() { if (_raf) { cancelAnimationFrame(_raf); _raf = 0; } }
    function clearPlayer() {
      stopTick();
      if (_onResize) { window.removeEventListener("resize", _onResize); _onResize = null; }
      if (player) { try { player.pause(); } catch (e) {} try { if (player.destroy) player.destroy(); } catch (e) {} player = null; }
      if (c.mount) c.mount.innerHTML = "";
    }
    function fmtClock(ms) { ms = Math.max(0, ms | 0); var s = Math.round(ms / 1000), m = Math.floor(s / 60); return m + ":" + ("0" + (s % 60)).slice(-2); }

    /* Drive rrweb's own Replayer directly (the rrweb-player wrapper silently fails to build its Replayer),
       with our own play/pause + speed + scrubber. rrweb.min.js must be loaded by pages.php. */
    function play(s) {
      clearPlayer();
      c.title.textContent = s.page_url;
      c.meta.textContent = trigLabel(s.trigger_kind) + " \u00b7 " + s.device + (s.browser ? " \u00b7 " + s.browser : "") + " \u00b7 " + fmtDur(s.duration_ms) + " \u00b7 " + (s.event_count || 0) + " events";
      c.mount.innerHTML = '<div class="sr-loading gs-muted">Loading replay&#8230;</div>';
      GS.api("/plugin/session-recordings/events?id=" + s.id + "&site=" + encodeURIComponent(GS.site || "")).then(function (r) {
        var events = (r.ok && r.data && r.data.events) || [];
        c.mount.innerHTML = "";
        if (events.length < 2) { c.mount.innerHTML = '<div class="sr-empty gs-muted">This recording is too short to replay.</div>'; return; }
        var meta0 = null, hasSnap = false;
        for (var i = 0; i < events.length; i++) { var ev = events[i]; if (ev && ev.type === 4 && !meta0) meta0 = ev.data; if (ev && ev.type === 2) hasSnap = true; }
        if (!hasSnap) { c.mount.innerHTML = '<div class="sr-empty gs-muted">This recording has no initial snapshot, so it can\u2019t be replayed.</div>'; return; }
        if (!(window.rrweb && rrweb.Replayer)) { c.mount.innerHTML = '<div class="sr-empty gs-muted">Replay engine failed to load. Ensure rrweb.min.js is deployed for this plugin.</div>'; return; }

        var stage = document.createElement("div"); stage.className = "sr-stage";
        var bar = document.createElement("div"); bar.className = "sr-ctrls";
        c.mount.appendChild(stage); c.mount.appendChild(bar);

        var replayer;
        try {
          replayer = new rrweb.Replayer(events, { root: stage, liveMode: false, mouseTail: false, speed: 1, skipInactive: false, showWarning: false });
        } catch (e) { c.mount.innerHTML = '<div class="sr-empty gs-muted">Could not replay this recording: ' + esc((e && e.message) || e) + "</div>"; return; }
        player = replayer;

        var recW = (meta0 && meta0.width) || 1024, recH = (meta0 && meta0.height) || 768;
        var totalMs = 0; try { totalMs = replayer.getMetaData().totalTime || 0; } catch (e) {}

        function fit() {
          var wrap = stage.querySelector(".replayer-wrapper"); if (!wrap) return;
          var avail = c.mount.clientWidth || stage.clientWidth || 640;
          var scale = Math.min(1, avail / recW);
          wrap.style.transformOrigin = "top left";
          wrap.style.transform = "scale(" + scale + ")";
          stage.style.width = Math.round(recW * scale) + "px";
          stage.style.height = Math.round(recH * scale) + "px";
        }
        fit(); setTimeout(fit, 60);
        _onResize = function () { fit(); }; window.addEventListener("resize", _onResize);

        var playing = false, curMs = 0, speed = 1, anchorWall = 0, anchorMs = 0;
        bar.innerHTML =
          '<button type="button" class="sr-btn sr-play" title="'+TT('sr.tip_playpause')+'"><i class="bi bi-play-fill"></i></button>' +
          '<button type="button" class="sr-btn sr-restart" title="'+TT('sr.tip_restart')+'"><i class="bi bi-skip-start-fill"></i></button>' +
          '<div class="sr-prog"><div class="sr-prog__fill"></div></div>' +
          '<span class="sr-time">0:00 / ' + fmtClock(totalMs) + '</span>' +
          '<span class="sr-speed">' + [1, 2, 4, 8].map(function (n) { return '<button type="button" class="sr-sp' + (n === 1 ? " on" : "") + '" data-sp="' + n + '">' + n + '\u00d7</button>'; }).join("") + "</span>";
        var btnPlay = bar.querySelector(".sr-play"), btnRestart = bar.querySelector(".sr-restart"),
            prog = bar.querySelector(".sr-prog"), fill = bar.querySelector(".sr-prog__fill"), timeEl = bar.querySelector(".sr-time");

        function setIcon() { btnPlay.innerHTML = '<i class="bi bi-' + (playing ? "pause" : "play") + '-fill"></i>'; }
        function render() {
          var pct = totalMs > 0 ? Math.min(100, curMs / totalMs * 100) : 0;
          fill.style.width = pct.toFixed(2) + "%";
          timeEl.textContent = fmtClock(curMs) + " / " + fmtClock(totalMs);
        }
        function tick() {
          if (!playing) return;
          curMs = anchorMs + (performance.now() - anchorWall) * speed;
          if (curMs >= totalMs) { curMs = totalMs; playing = false; setIcon(); render(); stopTick(); return; }
          render(); _raf = requestAnimationFrame(tick);
        }
        function doPlay(from) {
          if (typeof from === "number") curMs = from;
          if (curMs >= totalMs) curMs = 0;
          try { replayer.play(curMs); } catch (e) {}
          playing = true; anchorWall = performance.now(); anchorMs = curMs; setIcon(); stopTick(); _raf = requestAnimationFrame(tick);
        }
        function doPause() { try { replayer.pause(); } catch (e) {} playing = false; setIcon(); stopTick(); render(); }
        btnPlay.addEventListener("click", function () { playing ? doPause() : doPlay(); });
        btnRestart.addEventListener("click", function () { doPlay(0); });
        function seekFromEvent(e2) {
          var rect = prog.getBoundingClientRect();
          var x = (e2.touches ? e2.touches[0].clientX : e2.clientX) - rect.left;
          var pct = Math.max(0, Math.min(1, x / (rect.width || 1))), to = pct * totalMs;
          curMs = to; anchorMs = to; anchorWall = performance.now();
          try { if (playing) replayer.play(to); else replayer.pause(to); } catch (e) {}
          render();
        }
        prog.addEventListener("click", seekFromEvent);
        bar.querySelector(".sr-speed").addEventListener("click", function (e2) {
          var b = e2.target.closest("[data-sp]"); if (!b) return;
          speed = parseInt(b.getAttribute("data-sp"), 10) || 1;
          bar.querySelectorAll(".sr-sp").forEach(function (x) { x.classList.toggle("on", x === b); });
          try { replayer.setConfig({ speed: speed }); } catch (e) {}
          if (playing) { anchorMs = curMs; anchorWall = performance.now(); }
        });
        try { replayer.on("finish", function () { playing = false; curMs = totalMs; setIcon(); render(); stopTick(); }); } catch (e) {}

        setIcon(); render();
        doPlay(0);
      });
    }

    function srSiteNumId() { var a = (GS.sites || []); var s = a.filter(function (x) { return x.public_key === GS.site; })[0] || a[0]; return s ? s.id : 0; }
    function srEmptyReason(cl) {
      if (!cl) return "Give the site some traffic, and make sure your tracking snippet is current under <a href=\"/site-settings\">Site settings &rarr; Tracking</a>.";
      if (!cl.rec) return "Recording is off for this site on your current plan/limits. Turn up sampling under <a href=\"/site-settings\">Site settings &rarr; Data limits</a>, or upgrade your plan.";
      if ((cl.sample || 0) <= 0) return "Sampling is set to <strong>0%</strong> for this site, so no sessions are eligible to record. Raise it under <a href=\"/site-settings\">Site settings &rarr; Data limits</a>.";
      return "Sampling is on (<strong>" + cl.sample + "%</strong>)" + (cl.capped ? ", but the storage/daily cap is reached" : "") + ", but no visitor has hit a recording trigger (rage/dead click, JS error, or <code>gsRecord()</code>) yet. Make sure your tracking snippet is current under <a href=\"/site-settings\">Site settings &rarr; Tracking</a>.";
    }
    function srExplainInstall(inst) {
      var sid = srSiteNumId(); if (!sid) return;
      GS.api("/sites/data-limits?site_id=" + sid).then(function (r) {
        var cl = (r.ok && r.data && r.data.client) || null, m = inst.querySelector(".gs-muted.small");
        if (m) m.innerHTML = srEmptyReason(cl);
      })["catch"](function () {});
    }

    function render(sessions) {
      rows = sessions || [];
      if (c.install) { c.install.hidden = rows.length > 0; if (!rows.length) srExplainInstall(c.install); }
      // Delegated once on the tbody so rows revealed by "Load more" stay clickable.
      if (!c.list._srDelegated) { c.list._srDelegated = 1;
        c.list.addEventListener("click", function (e) {
          var tr = e.target.closest && e.target.closest("tr.sr-row"); if (!tr) return;
          c.list.querySelectorAll(".sr-row").forEach(function (x) { x.classList.remove("on"); });
          tr.classList.add("on");
          var s = rows.filter(function (x) { return String(x.id) === tr.getAttribute("data-id"); })[0];
          if (s) play(s);
        });
      }
      function srRow(s) {
        return '<tr class="sr-row" data-id="' + s.id + '">' +
          '<td class="sr-page text-truncate" title="' + esc(s.page_url) + '">' + esc(s.page_url) + "</td>" +
          "<td>" + trigBadge(s.trigger_kind) + "</td>" +
          "<td>" + devIcon(s.device) + "</td>" +
          "<td>" + esc(s.browser || "—") + "</td>" +
          "<td>" + fmtDur(s.duration_ms) + "</td>" +
          '<td class="gs-muted">' + fmtWhen(s.created_at) + "</td></tr>";
      }
      if (window.GSMore) GSMore.mount({ container: c.list, table: true, colspan: 6, items: rows, pageSize: 20, emptyText: TR('sessio.f2.no_recordings_match_these_filters'), render: srRow });
      else c.list.innerHTML = rows.length ? rows.map(srRow).join("") : '<tr><td colspan="6" class="gs-muted">'+TR('sessio.f2.no_recordings_match_these_filters')+'</td></tr>';
    }

    function loadList() {
      var q = "/plugin/session-recordings/list?site=" + encodeURIComponent(GS.site || "") +
        "&device=" + encodeURIComponent(device) +
        "&trigger=" + encodeURIComponent(c.trigger ? c.trigger.value : "") +
        "&page=" + encodeURIComponent(pageFilter) +
        "&from=" + RANGE.from + "&to=" + RANGE.to;
      c.list.innerHTML = '<tr><td colspan="6" class="gs-muted">Loading&#8230;</td></tr>';
      GS.api(q).then(function (r) {
        render((r.ok && r.data && r.data.sessions) || []);
        if (dl.id && !dl.opened) { dl.opened = true; playById(dl.id); }   // deep link to a specific recording
      });
    }

    c.deviceBtns.forEach(function (b) {
      b.addEventListener("click", function () {
        device = b.getAttribute("data-sr-device") || "";
        c.deviceBtns.forEach(function (x) { x.classList.toggle("on", x === b); });
        loadList();
      });
    });
    if (c.trigger) c.trigger.addEventListener("change", loadList);
    /* range reload handled by picker */

    renderChip();
    loadList();
  }

  /* Boot ONCE, after main.js has resolved GS.site — see the note in heatmap.js: booting on
     DOMContentLoaded fired every request with an empty site= and 404'd. */
  var _booted = false;
  function boot() {
 if (_booted) return; _booted = true; var r = document.querySelector('[data-sr="list"]'); if (r) init(document.body); }
  document.addEventListener("gs:ready", boot, { once: true });
  if (window.GS && GS.site) boot();
})();
